import { AuthService } from "./authentication/auth.service";
import { azureService } from "./utils";

export const hasUserPermission = (feature, access) => {
    const { isAzureFreePackage, isAzureBasicPackage, isAzurePremiumPackage } = azureService();
    const privileges = AuthService.getPrivilege();

    if (!privileges || privileges.length === 0) {
        return false;
    }

    if (isAzureFreePackage() && ["FAILURE_DIAGNOSIS", "ROOT_CAUSE_CONFIG", "KNOWLEDGE_BASE_UPLOADS", "CHAT_HISTORY", "MODEL_BUILDER", "MODEL_HUB", "FAILURE_ANALYTICS"].includes(feature)) {
        return false;
    }
    if (isAzureBasicPackage() && ["KNOWLEDGE_BASE_UPLOADS", "CHAT_HISTORY", "ROOT_CAUSE_CONFIG", "MODEL_BUILDER", "MODEL_HUB", "FAILURE_ANALYTICS"].includes(feature)) {
        return false;
    }

    const parts = feature.split(".");
    let currentLevel = privileges;
    
    for (let i = 0; i < parts.length; i++) {
        const part = parts[i].toUpperCase();
        const found = currentLevel.find(p => p.name.toUpperCase() === part);
        
        if (!found) {
            // console.log(`Permission ${part} not found in current level`);
            return false;
        }
        
        if (i === parts.length - 1) {
            if (!Array.isArray(found.actions)) {
                return false;
            }
            const action = found.actions.find(a => a.action_name.toUpperCase() === access.toUpperCase());
            return !!(action && action.selected);
        }
        
        if (!found.child || !Array.isArray(found.child)) {
            return false;
        }
        currentLevel = found.child;
    }
    
    return false;
};

